import { getAddToCartPayload } from '../../../../helpers/getAddToCartPayload';
import { Cart, ProductBuilderMachineContext } from '../../../../types';

export type AddToCart = (
  context: ProductBuilderMachineContext,
) => Promise<Cart>;

export const addToCartLive: AddToCart = async context => {
  try {
    const payload = getAddToCartPayload(context);
    const addToCart = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return await addToCart.json();
  } catch (error) {
    console.log('error?', error);
    return error;
  }
};
